// src/components/bsm/TransitGuideCard.js
import React, { useState } from 'react';
import { PinIcon, TrainIcon, ExternalLinkIcon, CopyIcon, CheckIcon } from './BsmIcons';

const TRANSIT_MODES = [
  {
    id: 'train',
    label: 'Local Train',
    landmark: 'Akurdi Railway Station (400 meters • 5 min walk)',
    details: 'Take any Pune-Lonavala suburban local train and alight at Akurdi Station. Walk towards the Old Mumbai-Pune Highway service road to Mayur Trade Center.',
  },
  {
    id: 'metro',
    label: 'PCMC Metro',
    landmark: 'PCMC Metro Station (Pimpri • 8 min auto ride)',
    details: 'Alight at PCMC Metro Station terminal. Frequent auto-rickshaws and cabs connect directly to Mayur Trade Center, Akurdi via the main arterial highway.',
  },
  {
    id: 'road',
    label: 'Bus & Highway',
    landmark: 'Old Mumbai-Pune Highway (Beside Hotel Radha Krishna)',
    details: 'Prime highway frontage with ample two-wheeler and four-wheeler parking at Mayur Trade Center, Section 20, Krushna Nagar, Akurdi.',
  },
];

export default function TransitGuideCard() {
  const [activeTab, setActiveTab] = useState('train');
  const [copied, setCopied] = useState(false);

  const fullAddress = "Brilliant Share Market Academy, Office No 204, 2nd Floor, Mayur Trade Center, Besides Hotel Radha Krishna, PL NO 4, F/2 Omkar App, Sec 20, Kasturi Market Rd, Krushna Nagar, Pimpri-Chinchwad, Pune, Maharashtra 411019.";

  const handleCopy = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(fullAddress);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    }
  };

  const currentMode = TRANSIT_MODES.find((m) => m.id === activeTab) || TRANSIT_MODES[0];

  return (
    <div className="transit-guide-card">
      <div className="transit-header">
        <div className="transit-title-row">
          <PinIcon width={16} height={16} className="transit-pin-ico" />
          <h4>Campus Transit &amp; Commute Directions</h4>
        </div>
        <button
          type="button"
          className="btn-copy-address"
          onClick={handleCopy}
          aria-label="Copy campus address to clipboard"
        >
          {copied ? (
            <>
              <CheckIcon width={13} height={13} />
              <span>Copied!</span>
            </>
          ) : (
            <>
              <CopyIcon width={13} height={13} />
              <span>Copy Address</span>
            </>
          )}
        </button>
      </div>

      <div className="transit-tabs-nav">
        {TRANSIT_MODES.map((mode) => (
          <button
            type="button"
            key={mode.id}
            className={`transit-tab-btn ${activeTab === mode.id ? 'active' : ''}`}
            onClick={() => setActiveTab(mode.id)}
          >
            {mode.id === 'train' && <TrainIcon width={14} height={14} />}
            {mode.id === 'metro' && <PinIcon width={14} height={14} />}
            {mode.id === 'road' && <ExternalLinkIcon width={13} height={13} />}
            <span>{mode.label}</span>
          </button>
        ))}
      </div>

      <div className="transit-tab-content">
        <strong className="transit-landmark">{currentMode.landmark}</strong>
        <p className="transit-details">{currentMode.details}</p>
      </div>
    </div>
  );
}
